module.exports = __webpack_public_path__ + "static/media/benefits-img-1.90bf1a87.png";